// extracted by mini-css-extract-plugin
module.exports = {"centerSection":"style_centerSection__2aU7r","extraLinks":"style_extraLinks__2TtU8"};